var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNextCheckpoint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99996 3.38379C7.38461 3.38379 5.25684 5.51156 5.25684 8.12691C5.25684 10.7423 7.38461 12.87 9.99996 12.87C12.6153 12.87 14.7431 10.7422 14.7431 8.12687C14.7431 5.51152 12.6153 3.38379 9.99996 3.38379ZM9.09824 10.6904L7.10668 8.69887L7.93531 7.87023L9.09824 9.03316L12.1537 5.97769L12.9823 6.80633L9.09824 10.6904Z",
    fill: "#919EAB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0003 0C5.4166 0 1.6875 3.72906 1.6875 8.31277C1.6875 10.4641 2.50949 12.5061 4.00207 14.0626L10.0002 20L15.7207 14.339C16.5296 13.5707 17.1665 12.6659 17.6136 11.6497C18.0777 10.5947 18.3131 9.47203 18.3131 8.31273C18.313 3.72906 14.5839 0 10.0003 0ZM10.0003 14.0422C6.73875 14.0422 4.08527 11.3888 4.08527 8.12723C4.08527 4.8657 6.73875 2.21227 10.0003 2.21227C13.2618 2.21227 15.9153 4.86574 15.9153 8.12727C15.9153 11.3888 13.2618 14.0422 10.0003 14.0422Z",
    fill: "#919EAB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextCheckpoint);
export default __webpack_public_path__ + "static/media/next-checkpoint.c79771b489e42a79c89ae8a1fa7b239a.svg";
export { ForwardRef as ReactComponent };